export type TUTORIAL = {
  id: number;
  title: string;
  link: string;
};
export const tutorials: TUTORIAL[] = [
  {
    id: 1,
    title: "Results",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=8543s",
  },
  {
    id: 2,
    title: "Test Pages",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=8525s",
  },
  {
    id: 3,
    title: "Under/Over Optimize Keywords",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=8135s",
  },
  {
    id: 4,
    title: "Competitor Page Analysis",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=7790s",
  },
  {
    id: 5,
    title: "Quick Recap",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=7631s",
  },
  {
    id: 6,
    title: "HTML Header Tag",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=6229s",
  },
  {
    id: 7,
    title: "Analysis of Data in Json Format",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=6041s",
  },
  {
    id: 8,
    title: "Spy on DOM of all Competitors",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=5809s",
  },
  {
    id: 9,
    title: "DOM Vector",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=5674s",
  },
  {
    id: 10,
    title: "Related Entities",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=5615s",
  },
  {
    id: 11,
    title: "Image Entity",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=5443s",
  },
  {
    id: 12,
    title: "Neural Matching Analysis",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=5075s",
  },
  {
    id: 13,
    title: "Pro Tip on System Testing",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=4901s",
  },
  {
    id: 14,
    title: "Neural Matching",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=4625s",
  },
  {
    id: 15,
    title: "Pro Tip for Title Suggestion",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=4509s",
  },
  {
    id: 16,
    title: "Bert Testing",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=4256s",
  },
  {
    id: 17,
    title: " RankBrain: Meta Description",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=4003s",
  },
  {
    id: 18,
    title: "RankBrain: Name the Title",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=3806s",
  },
  {
    id: 19,
    title: "Analyze Keywords for SEO",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=3368s",
  },
  {
    id: 20,
    title: "Right URL for your Content",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=2982s",
  },
  {
    id: 21,
    title: "RankBrain: Name the URL",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=2898s",
  },
  {
    id: 22,
    title: "Advanced KeyWordSpy Tools for RankBrain Testing",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=2806s",
  },
  {
    id: 23,
    title: "Keyword Reports",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=2593s",
  },
  {
    id: 24,
    title: "Decision making Factors for Product Category",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=2526s",
  },
  {
    id: 25,
    title: "Pros and Cons in AI Spy",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=2454s",
  },
  {
    id: 26,
    title: "Drill down on AI Engine Results",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=2268s",
  },
  {
    id: 27,
    title: "Why to Look at Product Review AI",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=1927s",
  },
  {
    id: 28,
    title: "How to use AI Spy",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=1705s",
  },
  {
    id: 29,
    title: "RankBrain analysis",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=1435s",
  },
  {
    id: 30,
    title: "Testing behind the scenes",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=1132s",
  },
  {
    id: 31,
    title: "Remove signals out of analysis",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=956s",
  },
  {
    id: 32,
    title: "Pro Tip on Location Specific AI",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=627s",
  },
  {
    id: 33,
    title: "Keyword Searching",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=541s",
  },
  {
    id: 34,
    title: "How KeyWordSpy tool Works",
    link: "https://www.youtube.com/watch?v=prrSSRuBwN4&t=333s",
  },
];
